import React, {Component} from 'react';
import {getRunOffsImages} from '../utils';
import SpotReservationNotice from '../components/SpotReservationNotice'

const RunOffsDisplayImage = () => {

    const [RunOffsImage, RunOffsImage2] = getRunOffsImages();

    return (
      <div className="map-infobar__message" style={{}}>
        <div className="message-content">
          <img src={RunOffsImage} srcSet={`${RunOffsImage} 1x, ${RunOffsImage} 2x`} alt="" />
        </div>

        <SpotReservationNotice />
      </div>
    );
};

export default RunOffsDisplayImage;



// WEBPACK FOOTER //
// ./src/components/RunOffsDisplayImage.js